export default "__VITE_ASSET__ea182cd5__"